import { combineReducers } from 'redux';
import adress from './adress';
import method from './method';
import point from './point';
import zone from './zone';
import zoneData from './zoneData';
import zonesData from './zonesData';
import timeMethod from './timeMethod';
import deliveryTime from './deliveryTime';
import coords from './coords';

export default combineReducers({
  adress,
  method,
  point,
  zone,
  zoneData,
  zonesData,
  timeMethod,
  deliveryTime,
  coords,
});
